import { IBasketProduct } from "../../types";

export const isInBusket = (cart: IBasketProduct[], name: string, id: number) => {
    let isThere = false;
    cart.forEach((el) => {
        if (el.detailName === name && el.id === id) {
            isThere = true;
        }
    });
    return isThere;
}